import * as sell from 'model/actions/utilities/_sell';
import { formatMessage } from 'model/message';
const MAX_SELL_FOOD = 10;

const messageText = ({ cost, gain }) => {
  return formatMessage('sold water', { cost, gain });
};

const value = (max, resultsVariable) => (resultsVariable ? Math.floor(Math.random() * max) : max);

const attempt = (price, resultsVariable) => {
  const cost = {
    food: value(MAX_SELL_FOOD, resultsVariable)
  };
  return sell.attempt(cost, price);
};

const sellFood = ({ context, resultsVariable }) => {
  // TODO: Use maxQuantity to limit the amount of food that the merchant will buy
  const [maxQuantity, price] = sell.adjustQuantityAndCost(context, 'food');

  return {
    title: 'Sell Food',
    cooldown: 0.2,
    enabled: () => context.party.resources.attribs.food.value >= MAX_SELL_FOOD,
    execute: context => {
      const result = attempt(price, resultsVariable);

      sell.executeSideEffects(context, result);

      return { result: { message: messageText(result) } };
    },
    tooltips: [['coins', `${price}`]]
  };
};

export default sellFood;
